import React from 'react';

const TwoFactorMethodModal = ({ isOpen, currentMethod, onSelectMethod, onClose }) => {
  if (!isOpen) return null;

  const methods = [
    { id: 'email', label: 'Email' },
    { id: 'sms', label: 'SMS' },
    {
      id:'security_questions', label: 'Security Question'
    }
  ];

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black bg-opacity-50 z-40"
        onClick={onClose}
      ></div>

      {/* Modal */}
      <div className="fixed inset-0 flex items-center justify-center z-50 p-4">
        <div className="bg-white rounded-lg shadow-xl w-auto">
          {/* Methods List */}
          <div className='p-4'>
            {methods.filter((method)=> method.id !== currentMethod).map((method, index) => (
              <button
                key={method.id}
                onClick={() => {
                  onSelectMethod(method.id);
                  onClose();
                }}
                className={`w-full px-4 py-3 text-jet-gray-700 hover:bg-jet-gray-50 transition-colors duration-200 text-center font-medium text-sm border-b`}
                style={{
                  borderColor: 'rgba(0,0,0,.125)',
                  borderWidth: '1px'
                }}
              >
                {method.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default TwoFactorMethodModal;
